import React from 'react'
import { ProgressBar } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import moment from 'moment'
import {
  $DCprimaryColor,
  DcFlexBox,
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
} from 'pixel-base'
import styled from 'styled-components'

interface Month {
  title: string
}

interface SummaryItem {
  courier_id: string
  courier_name: string
  settled_orders: number
  total_orders: number
}

interface MonthlyPaymentReportProps {
  month: Month
  summary: SummaryItem[]
  year: string
}

const getNumericMonth = (month: string): string => {
  return moment().month(month).format('MM')
}

const MonthlyPaymentReport: React.FC<MonthlyPaymentReportProps> = ({
  month,
  summary,
  year,
}) => {
  return (
    <>
      <Section style={{ padding: '10px' }}>
        <SectionContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            height: '100%',
          }}
        >
          <SectionHeader>
            <SectionTitle>
              <Link
                to={`/payments/payments/month-wise-detail?month=${year}${getNumericMonth(
                  month.title,
                )}`}
              >
                {month.title}
              </Link>
            </SectionTitle>
          </SectionHeader>

          {summary.length > 0 ? (
            <>
              {summary.map((item) => (
                <DcFlexBox
                  height="auto"
                  flexDirection="column"
                  gap="10px"
                  key={item.courier_id}
                >
                  <Link
                    to={`/payments/payments/month-wise-detail?month=${year}${getNumericMonth(
                      month.title,
                    )}&courier=${item.courier_id}`}
                    style={{ textDecoration: 'none', color: '#2f3c4d' }}
                  >
                    <Row key={item.courier_id}>
                      <SummaryInfo>
                        <Name>{item['courier_name']}</Name>
                        <Info>
                          <span>
                            {item['settled_orders']} /{item['total_orders']}
                          </span>
                          &nbsp;
                          <small>
                            (
                            {(
                              (item['settled_orders'] / item['total_orders']) *
                              100
                            ).toFixed(3)}
                            )%
                          </small>
                        </Info>
                      </SummaryInfo>
                      <SummaryInfo>
                        <StyledProgressBar
                          variant="danger"
                          now={
                            (item['settled_orders'] / item['total_orders']) *
                            100
                          }
                        />
                      </SummaryInfo>
                    </Row>
                  </Link>
                </DcFlexBox>
              ))}
            </>
          ) : (
            <h3>No data found</h3>
          )}
        </SectionContent>
      </Section>
    </>
  )
}
const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px;
  border-radius: 5px;
  flex-direction: column;
  background: rgb(234 245 255);
  width: 100%;
  a {
    color: #2f3c4d !important;
    text-decoration: none !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  &:hover {
    box-shadow: rgba(65, 69, 88, 0.1) 0px 7px 14px 0px,
      rgba(0, 0, 0, 0.07) 0px 3px 6px 0px;
  }
`
const Name = styled.div`
  font-weight: bold;
`
const Info = styled.div`
  align-self: flex-end;
`
const SummaryInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
const StyledProgressBar = styled(ProgressBar)`
  width: 100%;
  height: 10px !important;
  border-radius: 5px;
  .progress-bar {
    background-color: ${$DCprimaryColor} !important;
  }
`

export default MonthlyPaymentReport
